export default __webpack_public_path__ + "static/media/hht2_home_img_EP20.1c4986e7.png";